// @ts-nocheck
import React, { FunctionComponent } from 'react';
import { FieldProps, getIn } from 'formik';

// MUI
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

// Common
import { GENERAL } from '../../../../../constants';
import { types } from '../../../../../types';

// Properties
import * as styles from './FormSelect.styles';

type TFormSelectProps = {
    options?: types.TBaseDictionaryField;
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isSelectGroup?: boolean;
}

const FormSelect: FunctionComponent<FieldProps & SelectProps & MenuItemProps & TFormSelectProps> = props => {
    const {
        handleChange,
        isSelectGroup,
        label,
        disabled,
        error,
        helperText,
        field,
        options,
        form
    } = props;

    const isTouched = getIn(form.touched, field.name);
    const errorMessage = getIn(form.errors, field.name);

    const fieldValue = disabled ? '' : field.value ?? '';

    const handleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (handleChange) {
            handleChange(event);
        } else {
            field.onChange(event);
        }
    }

    return (
        <FormControl
            disabled={disabled ?? !options}
            error={!isSelectGroup && (error ?? Boolean(isTouched && errorMessage))}
            sx={styles.selectField}
        >
            {
                label && (
                    <InputLabel
                        id={field.name}
                        shrink
                    >
                        {label}
                    </InputLabel>
                )
            }
            <Select
                name={field.name}
                labelId={field.name}
                variant="outlined"
                size="small"
                label={label}
                notched
                displayEmpty
                defaultValue=""
                value={fieldValue}
                onChange={handleSelectChange}
            >
                <MenuItem
                    key={''}
                    value={''}
                >
                    {GENERAL.SELECT_DEFAULT}
                </MenuItem>
                {
                    options ? options.map(option => (
                        <MenuItem
                            key={option.id}
                            value={option.id}
                        >
                            {option.name}
                        </MenuItem>
                    )) : null
                }
            </Select>
            <FormHelperText sx={styles.helper}>
                {!isSelectGroup && (helperText ?? ((isTouched && errorMessage) ? errorMessage : undefined))}
            </FormHelperText>
        </FormControl>
    );
};

export default FormSelect;
